import { MasterDataDetailPage } from "@/features/master-data/pages/MasterDataDetail";

const MasterDataDetail = () => {
  return <MasterDataDetailPage />;
};

export default MasterDataDetail;
